// ─────────────────────────────────────────────────────────────
// COLORS & THEME
// ─────────────────────────────────────────────────────────────
export const C = {
  bg: "#08090f",
  panel: "#0f111a",
  border: "#1c1f30",

  green: "#00e676",
  red: "#ff1744",
  yellow: "#ffd600",
  blue: "#4f8ef7",
  purple: "#a78bfa",

  text: "#f0f2ff",      // main bright text
  muted: "#a8b0cc",
  sub: "#c0c8e0",
};
